/**
 *  Filename ....: paste-selector.component.ts
 *  Created by ..: ianday
 *  on Date .....: 4/21/25
 **/
import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-paste-selector',
    templateUrl: './paste-selector.component.html',
    styleUrls: ['./paste-selector.component.css']
})

export class PasteSelectorComponent implements OnInit {

    public fileName: string = 'tempfilename.jpg';
    public url: string = '';

    @Output() onPasteSelected = new EventEmitter();
    constructor() {

    }
    ngOnInit() {

    }
    public onPasteHandler(event: ClipboardEvent): void {
        this.url = '';
        const items = (event.clipboardData || (event as any).clipboardData).items;
        let blob = null;
        for (const item of items) {
            if (item.type.indexOf('image') === 0) {
                blob = item.getAsFile();
                break;
            }
        }
        if (blob) {
            this.processImage(blob);
        }
    }
    public processImage(blob: Blob) {
        const reader = new FileReader();
        reader.onload = (event: any) => {
            this.url = event.target.result;
            this.convertBlobToJpeg(event.target.result);
        };
        reader.readAsDataURL(blob);
    }
    public convertBlobToJpeg(base64Image: string) {

        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, img.width, img.height);
            const dataUrl = canvas.toDataURL('image/jpeg');
            this.saveAsJpeg(dataUrl);
        };
        img.src = base64Image;
    }
    public saveAsJpeg(dataUrl: string) {

        this.onPasteSelected.emit(dataUrl);
       /* const link = document.createElement('a');
        link.href = dataUrl;
        this.url = dataUrl;
        link.click(); */
    }
    onKeyDown(ev: any): void {
        ev.preventDefault();
    }
}


